<template lang="pug">
	.yuxing-confirm
		.header
			img(src="@/assets/images/chongqing/yuxing-topImg.jpeg")
		.form
			div 恭喜您免费领取成功！
		.package-info
			img(src="@/assets/images/chongqing/packageinfo.png")
		.app
			img(src="@/assets/images/chongqing/app.png")
		.notice
			img(src="@/assets/images/chongqing/title.png")
			img(src="@/assets/images/chongqing/notice.png")
</template>

<script>
export default {
  name: 'CQYuxingSuccess',
  data() {
    return {
    }
  }
}
</script>
<style lang="less" scope>
.yuxing-confirm{
  background-color: #fff;
}
.header{
  img{
    width: 100%;
  }
}
.form{
	width: 75%;
  margin: 0 auto;
  background-color: #135AA6;
  padding: 1rem 1.5rem;
	color: #fff;
	text-align: center;
	button{
		width: 100%;
		margin: 1rem 0;
		background-color: rgb(241, 167, 48);
		color: #fff;
		border: 0;
	}
}
.app, .package-info{
  margin: 0 auto;
  width: 99%;
  img{
    width: 100%;
  }
  margin-top: 2rem;
}
.app{
  margin-top: 0;
}
.notice{
  margin: 0 auto;
  margin-top: 1rem;
  width: 90%;
  img{
    width: 100%;
  }
  margin-bottom: 6rem;
}
</style>